// extracted by mini-css-extract-plugin
module.exports = {"narrow":"style_narrow__3sPKg"};